import { SubjectRoles } from "@/api-schema-enums";
import { hasDevStageDeveloperAccess } from "@/common/helpers/has-dev-stage-developer-access";

export enum FabSettingsTab {
  Valuation = "valuation",
  BuyIn = "buy-in",
}

interface FabSettingsAccess {
  roles: readonly SubjectRoles[] | undefined;
  canManageBuyInSettings: boolean;
  isBuyInAvailable: boolean;
}

export function getAllowedFabSettingsTabs({
  roles,
  canManageBuyInSettings,
  isBuyInAvailable,
}: FabSettingsAccess): FabSettingsTab[] {
  const tabs: FabSettingsTab[] = [];

  if (hasDevStageDeveloperAccess(roles) || roles?.includes(SubjectRoles.FabVehicleValuationAdministrator)) {
    tabs.push(FabSettingsTab.Valuation);
  }
  if (canManageBuyInSettings && isBuyInAvailable) {
    tabs.push(FabSettingsTab.BuyIn);
  }

  return tabs;
}
